/**
 * Converts a string in 'hh:mm (AM|PM)' and returns the valid 24-hour format in an array.
 * [h, mm]
 */
export default function getTime(time) {
  const isValidTime = new RegExp("\\b\\d{2}:\\d{2} (AM|PM)\\b");

  if (isValidTime.test(time)) {
    const _time = time.split(" ");
    const timeSplit = _time[0].split(":");
    if (timeSplit[0] === "12") {
      if (_time[1] === "AM") {
        timeSplit[0] = "0";
      }
    } else if (_time[1] === "PM") {
      timeSplit[0] = (Number(timeSplit[0]) + 12).toString();
    }

    return timeSplit;
  }

  return [23, 59, 59];
}
